<template>
  <van-action-sheet v-model:show="isShow" :style="{ height: '80%' }" :title="titleTxt" safe-area-inset-bottom>
    <div class="content">
      <div v-show="showQR">
        <div class="showQR fhcud">
          <div class="couponCode">
            券码： <span class="codeNum">{{ datas.couponCode || '' }}</span>
          </div>
          <div class="dealerName">{{ datas?.dealerInfo?.name || '' }}</div>
        </div>
      </div>
      <div class="labelBox">
        <p>
          合同编码：<span class="value">{{ datas?.contractCode || '' }}</span>
        </p>
        <p>
          车辆：<span class="value">{{ datas?.carInfo?.plate || '' }} {{ datas?.carInfo?.model || '' }}</span>
        </p>
        <p>
          有效期：<span class="value">{{ datas?.activeMonth === -1 ? '无限制' : `${datas?.activeMonth || ''}个月` }}</span>
        </p>
        <!-- <p>
          生效时间：<span class="value">
            {{ getActiveTime(datas) }}
          </span>
        </p> -->
        <template v-if="!isEwCoupon(datas) || isEwCouponActivated(datas)">
          <p>
            生效开始时间：<span class="value">
              {{ isEwCoupon(datas) ? datas.activeStartTime : getActiveTime(datas)?.start || '' }}
              {{ isEwCoupon(datas) ? '（如因特殊原因涉及变更，请咨询经销商确认）' : '' }}
            </span>
          </p>
          <p>
            生效结束时间：<span class="value">
              {{ isEwCoupon(datas) ? (datas?.activeMonth === -1 ? '-' : datas.activeEndTime) : getActiveTime(datas)?.end || '' }}
              <span v-if="datas?.productType !== 'PRD_CATEGORY_7' && isEwCoupon(datas)">
                （如车辆行驶里程先于产品结束日期达到产品结束时车辆总行驶里程，以该时间为产品结束日期）
              </span>
            </span>
          </p>
        </template>
        <p>
          限制使用里程：<span class="value">{{ datas?.exceedMileEnd == -1 ? '不限制' : `${datas?.exceedMileEnd || ''} KM` }} </span>
        </p>
        <template v-if="!isEwCoupon(datas)">
          <p>
            联系人姓名：<span class="value">{{ maskCustomerName(datas?.customerName) }} </span>
          </p>
          <p>
            联系人手机号：<span class="value">{{ maskMobileNumber(datas?.customerMobile) }} </span>
          </p>
        </template>
      </div>
      <van-collapse v-model="activeNames" accordion>
        <van-collapse-item title="卡券描述" name="1">
          <div v-html="datas.description || '暂无'"></div>
        </van-collapse-item>
        <van-collapse-item title="使用条件" name="2">
          <div v-html="datas.useDescription || '暂无'"></div>
        </van-collapse-item>
        <div @click="viewUseDealer(datas)" style="padding:10px 16px;">
          <span class="viewUseDealerTitleClass">可使用经销商</span>
          <span class="viewUseDealerValueClass underline">点击查看</span>
        </div>
        <!-- 保养&延保 -->
        <div v-if="isEwCoupon(datas) || isScCoupon(datas)" @click="viewContractFn(datas)" style="padding:10px 16px;">
          <span class="viewUseDealerTitleClass">产品告知书</span>
          <span class="viewUseDealerValueClass underline">点击查看</span>
        </div>
      </van-collapse>
    </div>
  </van-action-sheet>
</template>

<script>
import { reactive, toRefs, watch, nextTick, computed } from 'vue'
// import QRCode from 'qrcodejs2'
import { onBeforeRouteLeave } from 'vue-router'
import { getStatusName, getActiveTime } from '@/util/directSales'
import { EWCouponType } from '@/util/order/staticConfig'

import moment from 'moment'
export default {
  props: ['datas', 'showPopUp', 'showQR', 'scene'],
  emits: ['viewUseDealer', 'viewContract'],
  setup(props, { emit }) {
    let { datas, showPopUp, showQR, scene } = toRefs(props)
    const state = reactive({
      isShow: false,
      datas,
      showQR,
      scene,
      showPopUp,
      activeNames: '1',
      disableImgUrl: '',
      qrcode: ''
    })
    // console.log(state.datas)
    onBeforeRouteLeave(() => {
      state.isShow = false
    })
    watch(
      () => state.showPopUp,
      () => {
        state.isShow = true
      }
    )
    let useState = item => {
      let isUse = ['', '不限制', '年', '季度', '月']
      let frequency = item.phaseTypeFlag === 1 ? '' : `，本${isUse[item.phaseTypeFlag]}可使用${item.phasedResidueUseNum}次`
      let phaseStr = item.phaseTypeFlag == 1 ? `` : `，每${item.phaseTypeName}可使用${item.phasedUseNum}次`
      let total = item.totalUseNum
      let used = item.usedNum
      return total > 0
        ? `共可使用${total}次${phaseStr} <br> 已使用${used}次，共剩余${total - used}次${frequency}`
        : !(phaseStr || frequency)
        ? '不限使用次数'
        : `${phaseStr.substring(1)}<br>${frequency.substring(1)}`
    }
    const titleTxt = computed(() => {
      // 2: 保养套餐 3:礼包 5:NEV 6:易损件 101:延保
      // (state.datas?.couponType === 2 ? '保养套餐详情' : '礼包券详情')
      switch (state.datas?.couponType) {
        case 2:
        case 5:
        case 6:
          return '保养套餐详情'
        case 3:
          return '礼包券详情'
        case 101:
          return '延长保修服务详情'
      }
    })
    const viewUseDealer = data => {
      emit('viewUseDealer', data)
    }
    const viewContractFn = data => {
      emit('viewContract', data)
    }
    const isEwCoupon = data => {
      return data.couponType === EWCouponType
    }
    const isScCoupon = data => {
      return data.couponType === 2
    }
    const isEwCouponActivated = data => {
      return data.couponType === EWCouponType && data.statusFlag !== 6
    }

    // 姓名加密处理：显示第1个字，后面都隐藏
    const maskCustomerName = name => {
      if (!name || typeof name !== 'string') return ''
      if (name.length === 1) return name
      return name.charAt(0) + '**'
    }

    // 手机号加密处理：显示前3位和后4位，中间隐藏
    const maskMobileNumber = mobile => {
      if (!mobile || typeof mobile !== 'string') return ''
      if (mobile.length < 7) return mobile // 长度不足7位的不处理
      if (mobile.length === 11) {
        // 标准11位手机号：139****5555
        return mobile.substring(0, 3) + '****' + mobile.substring(7)
      }
      // 其他长度的手机号也按照前3位后4位的规则处理
      const frontPart = mobile.substring(0, 3)
      const backPart = mobile.substring(mobile.length - 4)
      return frontPart + '****' + backPart
    }

    return {
      ...toRefs(state),
      useState,
      moment,
      viewUseDealer,
      titleTxt,
      getActiveTime,
      isEwCoupon,
      isScCoupon,
      isEwCouponActivated,
      viewContractFn,
      maskCustomerName,
      maskMobileNumber
    }
  }
}
</script>

<style lang="scss" scoped>
.box {
  padding: 15px 20px;
}
.viewUseDealerValueClass {
  // margin-left: 5px;
  // text-align: left !important;
  font-size: 14px;
  color: #969799;
}
.viewUseDealerTitleClass {
  // width: 200px !important;
  font-size: 14px;
  color: #323233;
  margin-right: 20px;
}
.title {
  font-size: 15px;
  font-weight: bold;
  color: #333333;
}
.content {
  font-size: 12px;
  color: #666666;
  text-align: left;
  padding: 10px 20px 60px;
}
button {
  margin-top: 28px;
}
.coupon {
  box-shadow: 0 0 7px 0 rgba(0, 0, 0, 0.05);
}
.showQR {
  font-size: 12px;
  color: #333333;
  padding-bottom: 16px;
  img {
    width: 100px;
    height: 100px;
  }
  .couponCode {
    margin: 10px 0 12px;
    font-weight: bold;
    font-size: 14px;
  }
}
.codeNum {
  font-size: 18px;
  color: #111;
  font-weight: 700;
}
.dealerName {
  color: #999;
  font-size: 16px;
  margin-bottom: 6px;
}
.useState {
  padding-top: 16px;
  border-top: 1px solid rgba(204, 204, 204, 0.23);
}
#qrcode {
  width: 100px;
  height: 100px;
  padding: 5px;
  box-shadow: 0 0 2px #666666;
  img {
    width: 100px;
    height: 100px;
  }
}
.disabled {
  width: 100px;
  height: 100px;
  background: url('../../assets/images/QRbg.png');
  background-size: 100%;
}
.dealer {
  :deep(.van-cell__value) {
    flex-basis: 50%;
  }
}
.labelBox {
  padding: 18px 14px;
  border-top: 1px solid rgb(233, 225, 225);
  border-bottom: 1px solid rgb(233, 225, 225);
  color: #222;
  font-size: 14px;
  line-height: 28px;
  .value {
    color: #666;
  }
  .value p {
    display: inline-block;
  }
}
</style>
